import React, { useContext, useEffect, useState } from 'react'
import PageWrapper from '../../components/PageWrapper/PageWrapper'
import { BARRIO, BUENOS_AIRES, CABA, CAPITAL, FORMULARIO_DOMICILIO, GEOLOCALIZACION_PAGE, LOCALIDAD, PROVINCIA, SELECCIONAR_DOMICILIO } from '../../utils/constants'
import { AsistenciaMedicaContext } from '../../contexts/AsistenciaMedicaContext'
import { Direccion } from '../../interfaces/direccion.interface'
import { IonCol, IonContent, IonGrid, IonRow } from '@ionic/react'
import { Button, CardNota, InputText, ListAutocomplete, Modal, Separador, Subtitulo, TextArea, TextLink, Titulo } from 'app-principal-componentes-visuales'
import { textIsValid } from '../../utils/utils'
import { useHistory } from 'react-router'
import { useDirecciones } from '../../hooks/useDirecciones'
import { Localidad } from '../../interfaces/localidad.interface'
import Normalizacion from '../../components/Modals/Normalizacion/Normalizacion'
import EliminarDomicilio from '../../components/Modals/EliminarDomicilio/EliminarDomicilio'
import { checkPermisosGeo, inicioLocationWeb } from '../../helpers/geolocalizacion'
import './FormularioDomicilio.scss'

type LocationState = {
    selectedDirection?: any;
    showEliminar?: boolean;
    direccionesSocio?: any;
    fromState?: string;
    isGeo: boolean;
    redirectTo?: string;
    propsRedirectTo?: {};
};

const initialStateDireccion: Direccion = { 
    barrio: '',
    calle: '',
    altura: '',
    piso: '',
    departamento: '',
    codigoPostal: '',
    latitud: 0,
    longitud: 0,
    entreCalleUno: '',
    entreCalleDos: '',
    localidad: '',
    provincia: '',
    posicionExacta: false,
    observaciones: '',
    seleccionado: true,
    barrioCerrado: false
};

type UbicacionState = typeof PROVINCIA | typeof LOCALIDAD | typeof BARRIO;

const FormularioDomicilio = () => {
    const history = useHistory();
    const { selectedDirection = null, isGeo, fromState, showEliminar, redirectTo, propsRedirectTo } = (history.location.state as LocationState) || {};
    const { asistenciaMedica, isWeb, useRequest, dispatchAsistenciaMedica } = useContext(AsistenciaMedicaContext);
    const { apiRequest } = useRequest();
    const { usuario: socioPrincipal, provincias } = asistenciaMedica;
    const [ newPlace, setNewPlace ] = useState(false);
    const [ placeToEdit, setPlaceToEdit ] = useState<UbicacionState>(PROVINCIA);
    const [ showModalEditPlace, setShowModalEditPlace ] = useState<boolean>(false);
    const [ showDeleteDirectionModal, setShowDeleteDirectionModal ] = useState(false);
    const [ direccion, setDireccion ] = useState<Direccion>(initialStateDireccion);
    const [ provinciasEncontradas, setProvinciasEncontradas ] = useState([]);
    const [ provinciasInicializadas, setProvinciasInicializadas ] = useState([]);
    const [ provinciaSearch, setProvinciaSearch ] = useState('');
    const [ localidadesEncontradas, setLocalidadesEncontradas ] = useState([]);
    const [ localidadesInicializadas, setLocalidadesInicializadas ] = useState([]);
    const [ localidadSearch, setLocalidadSearch ] = useState('');
    const [ localidadConBarrios, setLocalidadConBarrios ] = useState(false);
    const [ localidades, setLocalidades ] = useState<Localidad[]>();
    const [ barriosEncontrados, setBarriosEncontrados ] = useState([]);
    const [ barriosInicializados, setBarriosInicializados ] = useState([]);
    const [ barrioSearch, setBarrioSearch ] = useState('');
    const [ requiereBarrio, setRequiereBarrio ] = useState(false);
    const geolocalizacion = asistenciaMedica?.geolocalizacion;
    const { statusModulos } = asistenciaMedica;
    
    const { 
        stateMerlin,
        edicionDireccion,
        merlinWaiting,
        modifyDirection,
        addDirection,
        handleNormalizacion,
        showNormalizacionModal,
        setShowNormalizacionModal,
        updateDirection,
        handleNormalizacionEditar,
        handleCloseModal,
        handleCloseModalEdit
    } = useDirecciones({socioPrincipal, apiRequest, direccionesSocio: socioPrincipal?.direcciones, isGeo, redirectTo, propsRedirectTo});

    /**
    * Validacion del disable del boton guardar
    */
    const validPlace =     
        direccion.calle === '' || 
        direccion.altura === '' || 
        direccion.provincia === '' || 
        direccion.localidad === '' || 
        (requiereBarrio && direccion.localidad !== '' && direccion.barrio === '') || 
        direccion.observaciones?.length > 100;
    
    /** 
    * Inicializa la ubicacion de geolocalizacion
    */
    useEffect(() => {
        if(!geolocalizacion) {
            if (isWeb) {
                inicioLocationWeb(dispatchAsistenciaMedica);
            } else {
                checkPermisosGeo(dispatchAsistenciaMedica);
            }
        } 
    }, [])

    useEffect(() => {
        let nombresProvincias = provincias?.map( provincia => provincia.nombre );
        setProvinciasInicializadas(nombresProvincias);
    }, [provincias]) 

    useEffect(() => {
        if( selectedDirection && selectedDirection.calle ) {
            setNewPlace(false) 
            if(!(selectedDirection.provincia === BUENOS_AIRES && 
                selectedDirection.localidad === CABA || 
                selectedDirection.localidad === CAPITAL)
            ) {
                setProvinciaSearch(selectedDirection.provincia === CAPITAL ? CABA : selectedDirection.provincia)
                setLocalidadSearch(selectedDirection.localidad)
                setBarrioSearch(selectedDirection.barrio)
                setDireccion(selectedDirection);
                selectedDirection.barrio !== '' ? setLocalidadConBarrios(true) : setLocalidadConBarrios(false);
            } else {
                let direccionErronea = {...selectedDirection, provincia:'', localidad:''}
                setDireccion(direccionErronea);
            }
        } else {
            setNewPlace(true)
        }
    }, [ selectedDirection ])

    useEffect(() => {
        if( provincias && direccion.provincia ) {
            direccion.provincia = direccion.provincia === CAPITAL ? CABA : direccion.provincia;
            let prov = provincias.find( prov => prov.nombre === direccion.provincia );
            setLocalidades(prov.localidades);
            let nombresLocalidades = prov?.localidades?.map( loc => loc.nombre);
            setLocalidadesInicializadas(nombresLocalidades);
        }

    }, [ direccion.provincia, provincias ])

    useEffect(() => {
        if( localidades && direccion.localidad ) {
            let localidad = localidades.find( loc => loc.nombre === direccion.localidad );
            if ( localidad?.barrios.length > 0 ) {
                let nombresBarrios = localidad?.barrios?.map( loc => loc.nombre);
                setLocalidadConBarrios(true);
                setBarriosInicializados(nombresBarrios);
            } else {
                setDireccion({...direccion, barrio: ''});
                setLocalidadConBarrios(false);
                setBarriosEncontrados([]);
            }
        }
        
    }, [ direccion.localidad, localidades ])

    useEffect(() => {
        if(!newPlace && direccion.localidad && localidades && barriosEncontrados.length === 0 ){
            let localidad = localidades.find( loc => loc.nombre === direccion.localidad );
            if ( localidad?.barrios.length > 0 ) {
                let nombresBarrios = localidad.barrios?.map( loc => loc.nombre);
                setLocalidadConBarrios(true);
                setBarriosInicializados(nombresBarrios);
            } else {
                setDireccion({...direccion, barrio: ''});
            }
        }

    }, [newPlace, direccion.localidad])

    /**
    * Metodo encargado de ocultar el formulario para mostrar el modulo de searchbar para provincias, localidades, barrios
    * @param campo indica cual de los searchbars se va a renderizar
    */
    const handleEditPlace = (campo: UbicacionState) => {
        setShowModalEditPlace(true);
        setPlaceToEdit(campo)
    }

    /**
     * Metodo que cambia el estado de la direccion con la provincia que se selecciono del listado
     */
    const handleAcceptProvince = ( provinciaSeleccionada ) => {
        setProvinciaSearch(provinciaSeleccionada);
        setLocalidadesEncontradas([]);
        setLocalidadSearch("");
        setBarriosEncontrados([]);
        if(provinciaSeleccionada === CABA){
            setLocalidadConBarrios(true)
            setRequiereBarrio(true)
            setDireccion({...direccion, provincia:provinciaSeleccionada, localidad: CABA, barrio:''});
        }else{
            setLocalidadConBarrios(false)
            setRequiereBarrio(false)
            setDireccion({...direccion, provincia:provinciaSeleccionada, localidad:'', barrio:''});
        }
        setShowModalEditPlace(false)
    }

    /**
     * Metodo que setea en el state el input de provincias al realizarse una modificacion y filtra las provincias mostradas en pantalla
     */
    const handleInputChangeProvince = ({target}) => {
        let {value} = target;
        if(provinciaSearch !== value) {
            if (value.length < 3) {
                setProvinciasEncontradas([]);
            } else { 
                let provinciasBuscadas = provinciasInicializadas.filter((item) => {return item.toUpperCase().includes(value.toUpperCase())});
                setProvinciasEncontradas(provinciasBuscadas);
            }
            setProvinciaSearch(value);
        }
    }

    /**
     * Metodo que cambia el estado de la direccion con la localidad que se selecciono del listado
     */
    const handleAcceptLocalities = ( localidadSeleccionada ) => {
        setDireccion({...direccion, localidad:localidadSeleccionada, barrio:''});
        setLocalidadSearch(localidadSeleccionada);
        setBarrioSearch('');
        setShowModalEditPlace(false)
    }

    /**
     * Metodo que setea en el state el input de localidades al realizarse una modificacion y filtra las localidades mostradas en pantalla
     */
    const handleInputChangeLocalities = ({target}) => {
        let {value} = target;
        if(localidadSearch !== value) {
            if (value.length < 3) {
                setLocalidadesEncontradas([]);
            } else { 
                let localidadesBuscadas = localidadesInicializadas.filter((item) => {return item.toUpperCase().includes(value.toUpperCase())})
                setLocalidadesEncontradas(localidadesBuscadas);
            }
            setLocalidadSearch(value);
        }
    }

    /**
    * Metodo que cambia el estado de la direccion con el barrio que se selecciono del listado
    */
    const handleAcceptNeighborhood = ( barrioSeleccionado ) => {
        setDireccion({...direccion, barrio:barrioSeleccionado});
        setBarrioSearch(barrioSeleccionado);
        setShowModalEditPlace(false)
    }

    /**
    * Metodo que permite mostrar el formulario al cancelarse el ListAutocomplete
    */
    const handleCancel = (direccionCancel: UbicacionState) => {
        if (direccionCancel === PROVINCIA) {
            if(direccion.provincia !== '') {
                setProvinciaSearch(direccion.provincia);
            } else {
                setProvinciaSearch('')
                setProvinciasEncontradas([]);
            }
        }
        else if (direccionCancel === LOCALIDAD) {
            if(direccion.localidad !== '') {
                setLocalidadSearch(direccion.localidad);
            } else {
                setLocalidadesEncontradas([]);
                setLocalidadSearch('');
            }
        }
        else if (direccionCancel === BARRIO) {
            if(direccion.barrio !== '') {
                setBarrioSearch(direccion.barrio);
            } else {
                setBarriosEncontrados([]);
                setBarrioSearch('');
            }
        }
        setShowModalEditPlace(false);
    }

    /**
     * Metodo que setea en el state el input de la calle al realizarse una modificacion
     */
    const handleCalleChange = (calle) => {
        const noSpacesValue = calle.target.value.replace(/^\s+/, '');
        const isValid = textIsValid(calle.target.value)
        if(isValid){
            setDireccion({...direccion, calle: noSpacesValue})
        } 
    }

    /**
     * Metodo que setea en el state el input de la altura al realizarse una modificacion
     */
    const handleAlturaChange = (altura) => {
        const isValid = textIsValid(altura.target.value)
        if(isValid){
            setDireccion({...direccion, altura:altura.target.value})
        } 
    }

    /**
     * Metodo que setea en el state el input del piso al realizarse una modificacion
     */
    const handlePisoChange = (piso) => {
        const noSpacesValue = piso?.target?.value?.replace(/^\s+/, '');
        const isValid = textIsValid(piso.target.value)
        if(isValid){
            setDireccion({...direccion, piso: noSpacesValue});
        } 
    }

    /**
     * Metodo que setea en el state el input del departamento al realizarse una modificacion
     */
    const handleDepartamentoChange = (departamento) => {
        const noSpacesValue = departamento?.target?.value?.replace(/^\s+/, '');
        const isValid = textIsValid(departamento.target.value)
        if(isValid){
            setDireccion({...direccion, departamento: noSpacesValue});
        } 
    }

    /**
     * Metodo que setea en el state el input de las observaciones al realizarse una modificacion
     */
    const handleObservacionesChange = (observaciones) => {
        const noSpacesValue = observaciones.target.value.replace(/^\s+/, '');
        const isValid = textIsValid(observaciones.target.value)
        if(isValid){
            setDireccion({...direccion, observaciones: noSpacesValue});
        } 
    }

    /**
     * Metodo que setea en el state el input del barrio al realizarse una modificacion y filtra los barrios mostrados en pantalla
     */
    const handleInputChangeNeighborhood = ({target}) => {
        let {value} = target;
        if(barrioSearch !== target) {
            if (value.length < 3) {
                setBarriosEncontrados([]);
            } else { 
                let barriosBuscados = barriosInicializados.filter((item) => {return item.toUpperCase().includes(value.toUpperCase())})
                setBarriosEncontrados(barriosBuscados)
            }
            setBarrioSearch(value);
        }
    }

    /**
     * Metodo que elimina la direccion seleccionada del socio principal
     */
    const deleteDirection = (direccionId) => {
        let direccionSinSeleccionado = [];
        const direccionFiltrada = socioPrincipal?.direcciones?.filter(direccion => {
            return direccionId !== direccion.id
        });

        if (direccionId === selectedDirection.id && direccionFiltrada.length !== 0) {
            direccionSinSeleccionado = direccionFiltrada.map((direccion, index) => {
                if (index === direccionFiltrada.length - 1) {
                    let dirSelected = { ...direccion, seleccionado: true }
                    return dirSelected
                }
                return direccion
            });
        }
        updateDirection(direccionSinSeleccionado.length > 0 ? direccionSinSeleccionado : direccionFiltrada);
        setShowDeleteDirectionModal(!showDeleteDirectionModal);
        
        history.goBack();
    }

    /**
     * Encargado de abrir/cerrar el modal de eliminacion de direcciones
     */
    const openDeleteDirection = () => setShowDeleteDirectionModal(showDelete => !showDelete);

    /**
     * Metodo que realiza el llamado a la modificacion o alta de una direccion
     */
    const handleSubmit = () => {
        if (direccion.provincia === CABA)
            direccion.provincia = CAPITAL
        if(newPlace || isGeo){
            addDirection(direccion)
        } else {
            modifyDirection(direccion)
        }
    }

    /**
     * Se usa history replace para que no quede historial de rutas 
     * para cuando se avance a la pantalla de sintomas luego de agregar la direccion
     */
    const handleClickGeo = () => {
        history.replace(GEOLOCALIZACION_PAGE, {redirectTo, propsRedirectTo})
    }

    const onHandleClickNormalizar = (data) => {
        if(edicionDireccion) {
            handleNormalizacionEditar(data)
        } else {
            handleNormalizacion(data)
        }
    }

    const handleBack = () => {
        if(isGeo) {
            history.replace(GEOLOCALIZACION_PAGE, {redirectTo});
        } else if(newPlace) {
            history.replace(fromState || SELECCIONAR_DOMICILIO, {redirectTo});
        } else {
            history.goBack();
        }
    }

    const propsAutocompleteList = {
        provincia: {
            id: 'provincias-list',
            name: 'provinciaSearch',
            label: 'Provincia',
            placeholder: 'Elegí la provincia',
            list: provinciasEncontradas,
            valueInputDefault: provinciaSearch,
            aceptarValor: handleAcceptProvince,
            onClickCancelar: () => handleCancel(PROVINCIA),
            onHandleInputChange: handleInputChangeProvince,
        },
        localidad: {
            id: 'localidades-list',
            name: 'localidadSearch',
            label: 'Localidad',
            placeholder: 'Elegí la localidad',
            list: localidadesEncontradas,
            valueInputDefault: localidadSearch,
            aceptarValor: handleAcceptLocalities,
            onClickCancelar: () => handleCancel(LOCALIDAD),
            onHandleInputChange: handleInputChangeLocalities,
        },
        barrio: {
            id: 'barrio-list',
            name: 'barrioSearch',
            label: 'Barrio',
            placeholder: 'Elegí el barrio',
            list: barriosEncontrados,
            aceptarValor: handleAcceptNeighborhood,
            valueInputDefault: barrioSearch,
            onClickCancelar: () => handleCancel(BARRIO),
            onHandleInputChange: handleInputChangeNeighborhood,
        },
    }

    return (
        <PageWrapper 
            pageClassName='formulario-domicilio'
            socio={socioPrincipal} 
            path={FORMULARIO_DOMICILIO}
            tituloHeader='Datos de Ubicación'
            className={`asistencia-formulario ${isWeb ? 'mobile' : ''}`}
            handlerHandleBack={handleBack}
        >
            <IonGrid>
                <IonRow>
                    <IonCol className='titulo'>
                        <Titulo 
                            className="titulo-asitencia-formulario-domicilio"
                            titulo={newPlace || isGeo ? 'Nuevo domicilio' : 'Editar domicilio'} 
                        />
                    </IonCol>
                    {
                        (!newPlace && !isGeo) &&
                        <IonCol size='2' className='col__align'> 
                            { showEliminar && 
                                <TextLink
                                    id='asistencia__formulario-domicilio'
                                    onClick={openDeleteDirection}
                                    right
                                    texto="Eliminar"
                                />
                            }
                        </IonCol>
                    }
                </IonRow>
            </IonGrid>
            {
                newPlace && !isGeo && !statusModulos?.deshabilitarGeolocalizacion &&
                <IonGrid>
                    <IonRow>
                        <IonCol size='12' className='georeferencia__col'>
                            <CardNota
                                address
                                disabled={!geolocalizacion}
                                bgBlue
                                id="card-nota"
                                onClick={handleClickGeo}
                                texto="Usar mi ubicación actual"
                            />
                        </IonCol>
                    </IonRow> 
                </IonGrid>
            }
            <IonGrid>
                <IonRow>
                    <IonCol size='12'>
                        <Subtitulo
                            titulo="Cargar datos manualmente"
                            txt16
                        />
                    </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol size='12'>
                        <InputText
                            id='formulario-input-calle'
                            label='Calle'
                            normalLink
                            placeholder='Ingresá solo el nombre de la calle'
                            type='text'
                            value={direccion.calle} 
                            onIonChange={handleCalleChange}
                        />
                    </IonCol>
                    <IonCol size='12' className='col--padding-top'>
                        <InputText
                            id='formulario-input-numero'
                            label='Número'
                            normalLink
                            placeholder='Ingresá la altura'
                            type="number"
                            inputmode="number"
                            value={direccion.altura} 
                            onIonChange={handleAlturaChange}
                        />
                    </IonCol>
                    <IonCol size='6' className='col--padding-right col--padding-top'>
                        <InputText
                            id='formulario-input-piso'
                            label='Piso'
                            normalLink
                            placeholder='Opcional'
                            type='text'
                            value={direccion.piso} 
                            onIonChange={handlePisoChange}
                        />
                    </IonCol>
                    <IonCol size='6' className='col--padding-left col--padding-top'>
                        <InputText
                            id='formulario-input-departamento'
                            label='Departamento'
                            normalLink
                            placeholder='Opcional'
                            type='text'
                            value={direccion.departamento}
                            onIonChange={handleDepartamentoChange}
                        />
                    </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol size='12' className='col--padding-top'>
                        <InputText
                            id='formulario-input-provincia'
                            elegirLink
                            label='Provincia'
                            onClick={() => handleEditPlace(PROVINCIA)}
                            placeholder='Elegí la provincia'
                            type='text'
                            value={direccion.provincia === CAPITAL ? CABA : direccion.provincia} 
                        />
                    </IonCol>
                    <IonCol size='12' className='col--padding-top'>
                        <InputText
                            id='formulario-input-localidad'
                            disable = { direccion.provincia === undefined || direccion.provincia === '' }
                            elegirLink
                            label='Localidad'
                            onClick={() => handleEditPlace(LOCALIDAD)}
                            placeholder='Elegí la localidad'
                            type='text'
                            value={direccion.localidad} 
                        />
                    </IonCol>
                    { localidadConBarrios && (
                        <IonCol size='12' className='col--padding-top'>
                            <InputText
                                id='formulario-input-barrio'
                                disable = { direccion.localidad === undefined || direccion.localidad === ''}
                                elegirLink
                                label='Barrio'
                                onClick={() => handleEditPlace(BARRIO)}
                                placeholder='Elegí el barrio'
                                type='text'
                                value={direccion.barrio} 
                            />
                        </IonCol>
                    )}
                </IonRow>
                <Separador />
                <IonRow>                               
                    <IonCol size='12'>
                            <Subtitulo 
                                id="subtitulo-info" 
                                titulo='¿Hay información adicional que quieras comentarnos?' 
                            />
                    </IonCol>
                    <IonCol size='12'>
                        <TextArea
                            id="text-area-info-adicional"
                            label='Información adicional'
                            maxLength={100}
                            onIonChange={handleObservacionesChange}
                            placeholder='Ingresá tu manzana, country, lote, etc.'
                            value={direccion.observaciones} 
                        />
                    </IonCol>
                    <IonCol size='12' className='guardar-cambios'>
                        <Button 
                            id='formulario-domicilio-guardar'
                            className='button--margin' 
                            label={ newPlace ? 'Agregar':'Guardar cambios' } 
                            onClick={ handleSubmit }
                            disable={ validPlace }
                            waiting={ Boolean(merlinWaiting) } 
                            primary 
                        />
                    </IonCol>
                </IonRow>
            </IonGrid>

            {/* MODALES */}
            <Modal
                className='modal_web-large'
                component={
                    <IonContent className='asistencia-formulario'>
                        <IonGrid className='asistencia-formulario__header'>
                            <IonRow>
                                <IonCol size='12' className='titulo'>
                                    <Titulo titulo={'Nuevo domicilio'} />
                                </IonCol>
                            </IonRow>
                        </IonGrid>
                        <IonGrid style={{marginTop:'120px'}}>
                            <IonRow style={{display: 'flex', justifyContent: 'center'}}>
                                <IonCol size='11'>
                                    <ListAutocomplete
                                        {...propsAutocompleteList[placeToEdit]}
                                    />
                                </IonCol>
                            </IonRow>
                        </IonGrid>
                    </IonContent>
                }
                setShowModal={setShowModalEditPlace}
                showModal={showModalEditPlace}
                id="formulario-domicilio-modal"
            />

            <Modal
                className='modal_web'
                screen60
                hideCloseBtn
                //@ts-ignore
                component={
                    <Normalizacion
                        isWeb={isWeb}
                        onClick={onHandleClickNormalizar}
                        closeModal={edicionDireccion ? handleCloseModalEdit : handleCloseModal}
                        data={stateMerlin}
                    />
                }
                setShowModal={setShowNormalizacionModal}
                showModal={showNormalizacionModal}
                id="modal-normalizacion"
            />

            <Modal
                className='modal_web_xl'
                hideCloseBtn
                //@ts-ignore
                component={
                    <EliminarDomicilio
                        openDeleteDirection={openDeleteDirection} 
                        selectedDirection={selectedDirection} 
                        deleteDirection={deleteDirection} 
                        isWeb={isWeb} 
                    />
                }
                setShowModal={setShowDeleteDirectionModal}
                showModal={showDeleteDirectionModal}
                id="eliminar-domicilio-modal"
            />
        </PageWrapper>
    )
}

export default FormularioDomicilio
